<template lang="pug">
include ../pug/svg
div.block(:class="blockClasses" @mouseleave="focus=null" :style="blockStyles")
	picture.icon(v-if="block.settings.icon.name")
		span.material-symbols-rounded(:class="block.settings.icon.name" :style="{'color':iconColour()}") {{block.settings.icon.name}}
	contenteditable(tag="h2" :spellcheck="(focus===1)" :class="{fade:focus&&focus!==1}" v-model="block.content.headed" :noNL="true" @focus="focus=1" @blur="focus=null" @keyup="blockUpdated")
	contenteditable.p(tag="div" :spellcheck="(focus===2)" :class="{fade:focus&&focus!==2}" v-model="block.content.onecolumn" :noNL="false" :noHTML="false" @focus="focus=2" @blur="focus=null" @keyup="blockUpdated")
	div.modal.settings(v-if="block.settings.active")
		ModalBar(label="Block Settings" :useDrag="true" @close="toggleSettings()")
		form.body
			fieldset.fgroup
				FieldAlign(
					class="c2"
					v-model:alignHorz="block.settings.alignHorz"
					@fieldUpdated="blockUpdated")
				FieldPadding(
					class="c2"
					v-model:padTop="block.settings.padTop"
					v-model:padBottom="block.settings.padBottom" 
					@fieldUpdated="blockUpdated")
				FieldBackgroundColour(
					class="c2"
					v-model:bgColor="block.settings.bgColor"
					v-model:whiteText="block.settings.whiteText" 
					@fieldUpdated="blockUpdated")
				FieldIcon(
					class="c2"
					v-model:name="block.settings.icon.name"
					v-model:colour="block.settings.icon.color" 
					@fieldUpdated="blockUpdated")
				FieldRatio.c2(
					v-model:ratio="block.settings.minRatio"
					label="Minimum Block Ratio"
					@fieldUpdated="blockUpdated")
			div.foot
				span.req Required
				button.but.pri(type="button" @click="toggleSettings()") Apply
				button.but.sec(type="button" @click="resetSettings()") Reset
</template>

<script>
import contenteditable from 'vue-contenteditable';
import FieldBackgroundColour from '../components/FieldBackgroundColour';
import FieldPadding from '../components/FieldPadding';
import FieldAlign from '../components/FieldAlign';
import FieldRatio from '../components/FieldRatio';
import FieldIcon from '../components/FieldIcon';
import ModalBar from '../components/ModalBar';

export default {
	name: 'BlockTextHeaded',
	props:['block'],
	emits: ['blockUpdated', 'toggleSettings', 'resetSettings'],
	components: {
		contenteditable,
		ModalBar,
		FieldBackgroundColour,
		FieldPadding,
		FieldAlign,
		FieldRatio,
		FieldIcon,
	},
	data() {
		return {
			focus: null,
			nullValue: null,
			
			drag: {
				el: null,
				clientX: null,
				clientY: null,
				moveX: 0,
				moveY: 0,
			}
		}
	},
	computed: {
		settings() {
			return this.block.settings;
		},
		blockStyles() {
			let styles = [];

			if (this.settings.bgColor) {
				styles.push('background-color:#'+this.settings.bgColor);
			}

			return styles.join(';');
		},
		blockClasses() {
			let classes = [
				this.block.type,
				this.block.subtype,
			];

			if (this.settings.alignHorz) {
				classes.push(this.settings.alignHorz);
			}

			if (this.settings.padTop) {
				classes.push(this.settings.padTop);
			}

			if (this.settings.padBottom) {
				classes.push(this.settings.padBottom);
			}

			if (this.settings.whiteText) {
				classes.push('whitetext');
			}
			
			return classes.join(' ');
		},
	},
	methods: {
		blockUpdated() {
			this.$emit('blockUpdated');
		},
		toggleSettings() {
			this.$emit('toggleSettings', this.block);
		},
		resetSettings() {
			this.$emit('resetSettings', this.block);
		},
		iconColour() {
			// check for valid hex values (e.g(#FFF / #FFFFFF)
			const hexRegex = /^#([0-9A-F]{3}){1,2}$/i;
			const valid = hexRegex.test('#'+this.settings.icon.color);
			
			return valid ? '#' + this.block.settings.icon.color : null; // default
		},
	},
}
</script>

<style lang="scss">
</style>
